import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import StockChart from '../components/StockChart';
import './PageIndustriaAnio.css';

const DATA = [
  { year: 2010, value: 53639600 },
  { year: 2011, value: 59326602 },
  { year: 2012, value: 76716466 },
  { year: 2013, value: 91353118 },
  { year: 2014, value: 113875922 },
  { year: 2015, value: 112519608 },
  { year: 2016, value: 124760391 },
  { year: 2017, value: 117203460 },
  { year: 2018, value: 105599016 },
  { year: 2019, value: 97859142 },
  { year: 2020, value: 89831618 },
  { year: 2021, value: 102582388 },
  { year: 2022, value: 111078086 },
  { year: 2023, value: 102383141 },
  { year: 2024, value: 126057161 },
  { year: 2025, value: 133818689 },
];

const EVENTS = [
  { year: 2010, label: 'Porfirio Lobo' },
  { year: 2014, label: 'JOH (1er Término)' },
  { year: 2017, label: 'JOH Anuncia Reelección' },
  { year: 2020, label: 'COVID-19' },
  { year: 2022, label: 'Xiomara Castro' },
];

function PageIndustriaTransnacional() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="industria-page">
        <header className="industria-header">
          <button className="btn-back" onClick={() => navigate('/industria-anio-domestica')}>
            &#8592; Dom&eacute;stico
          </button>
          <div className="industria-title-block">
            <h1 className="industria-title">Capital Transnacional</h1>
            <p className="industria-subtitle">Inversi&oacute;n publicitaria &middot; Anunciantes transnacionales &middot; Honduras 2010–2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/industria-anio-gobierno')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <StockChart data={DATA} color="#93c5fd" events={EVENTS} />

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageIndustriaTransnacional;
